<template>
    <b-navbar toggleable="lg" type="dark" variant="" class="p-3 px-lg-5">
        <b-navbar-brand href="#" class="text-lg-left">
            <router-link to="/" active-class="logo-link">
                <img src="../assets/images/logo/stdenislogo.jpeg" alt="saint denis logo"> St. Denis
            </router-link>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-navbar-nav>
                    <b-nav-item @click.prevent="navigate_to_page('home')" active>Home</b-nav-item>
                    <b-nav-item-dropdown text="Parish Program" right>
                        <b-dropdown-item href="#" @click.prevent="navigate_to_page('weeklyprograms')"><a>Weekly
                            program</a></b-dropdown-item>
                        <b-dropdown-item href="#" @click.prevent="navigate_to_page('upcomingprograms')">Upcoming
                            program
                        </b-dropdown-item>
                        <b-dropdown-item href="#" @click.prevent="navigate_to_page('announcement')">Announcements
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-nav-item @click.prevent="navigate_to_page('societies')">Societies</b-nav-item>
                    <b-nav-item @click.prevent="navigate_to_page('contact')">Contact us</b-nav-item>
                    <b-nav-item @click.prevent="navigate_to_page('download')">Download</b-nav-item>
                    <b-nav-item @click.prevent="navigate_to_page('signup')">Sign Up <i class="icon ion-md-person"></i>
                    </b-nav-item>
                    <b-nav-item @click.prevent="navigate_to_page('login')">Login <i class="icon ion-md-log-in"></i>
                    </b-nav-item>
                </b-navbar-nav>

                <div>
                    <b-button id="show-btn" size="sm" class="my-2 offset-lg-0 stdenis-btn"
                              target="_blank" href="https://rave.flutterwave.com/donate/5kfxagsbhgmb" >
                        <i class="icon ion-md-wallet"></i> Donate
                    </b-button>

                    <!-- Donate Modal -->
                    <b-modal id="bv-modal-example" no-close-on-backdrop hide-footer>
                        <template v-slot:modal-title>
                            Make Donation
                        </template>
                        <div class="d-block text-center">
                            <b-form @submit="onSubmit" v-if="show">
                                <b-form-group id="input-group-1" label="Name:" label-for="input-1" class="text-left">
                                    <b-form-input id="input-1" v-model="form.name" type="text" required
                                                  placeholder="Name"></b-form-input>
                                </b-form-group>
                                <b-form-group id="input-group-2" label="Amount:" label-for="input-2" class="text-left">
                                    <b-form-input id="input-2" v-model="form.amount" type="number" required
                                                  placeholder="Amount"></b-form-input>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Purpose:" label-for="input-3" class="text-left">
                                    <b-form-input id="input-3" v-model="form.purpose" type="text" required
                                                  placeholder="Purpose"></b-form-input>
                                </b-form-group>

                                <b-button type="submit" class="btn stdenis-btn">Donate <i class="icon ion-md-thumbs-up"
                                                                                          style="color:#fff"></i>
                                </b-button>
                                <b-button class="btn stdenis-btn stdenis-btn-dark"
                                          @click="$bvModal.hide('bv-modal-example')">Close <i
                                        class="icon ion-md-close-circle-outline" style="color:#fff"></i></b-button>

                            </b-form>
                        </div>
                    </b-modal>
                </div>


            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js'

    export default {
        name: "NavBar",
        data() {
            return {
                form: {
                    name: '',
                    amount: '',
                    purpose: ''
                },
                show: true
            }
        },
        methods: {
            navigate_to_page(page) {
                switch (page) {
                    case 'contact':
                        this.$router.push({path: '/contact'});
                        break;
                    case 'home':
                        this.$router.push({path: '/'});
                        break;
                    case 'weeklyprograms':
                        this.$router.push({path: '/weeklyprograms'});
                        break;
                    case 'upcomingprograms':
                        this.$router.push({path: '/upcomingprograms'});
                        break;
                    case 'announcement':
                        this.$router.push({path: '/announcement'});
                        break;
                    case 'societies':
                        this.$router.push({path: '/societies'});
                        break;
                    case 'signup':
                        this.$router.push({path: '/signup'});
                        break;
                    case 'login':
                        this.$router.push({path: '/login'});
                        break;
                    case 'download':
                        this.$router.push({name: 'AppDownload'});
                        break;
                }

            },
            onSubmit(evt) {
                evt.preventDefault();
                // alert(JSON.stringify(this.form));
                this.$bvModal.hide('bv-modal-example');
                setTimeout(() => {
                    Swal.fire('Thank you!', 'Payment made successfully', 'success');
                    this.form.name = this.form.amount = this.form.purpose = ''
                }, 500)

                ;
            },
        },
        created() {
            // When the user scrolls the page, execute myFunction
            window.onscroll = function () {
                myFunction()
            };

            // Get the navbar
            let navbar = document.getElementsByTagName("nav");

            // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
            function myFunction() {
                if (window.pageYOffset >= 100) {
                    navbar[0].classList.add("sticky")
                } else {
                    navbar[0].classList.remove("sticky");
                }
            }
        },
        gotoDonation() {
            location.href = "https://rave.flutterwave.com/donate/5kfxagsbhgmb";
        }
    }
</script>

<style scoped>
    @media screen and (min-width: 320px) {
        .navbar {
            /*position: block;*/
            z-index: 999;
            background-color: #439EF3;
            font-family: "Montserrat", sans-serif !important;
            font-weight: bold;
            transition: all 1s ease-in-out;
            width: 100% !important;
        }

        .navbar-collapse {
            background-color: rgba(0, 0, 0, .7);
            color: #fff;
        }

        .navbar-dark .navbar-nav .nav-link, .navbar-dark .navbar-nav .nav-link em {
            color: #fff;
        }

        .navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link em:hover {
            color: #E12993 !important;
        }

        .navbar .navbar-brand img {
            width: 30px;
            height: auto;
        }

        .logo-link:hover {
            color: #fff;
        }
    }

    @media screen and (min-width: 1024px) {
        .navbar-collapse {
            background-color: transparent;
            color: #fff;
        }

        .navbar-brand {
            font-size: 2rem;
        }
    }

</style>